import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Regioverantwoordelijke} from '../regioverantwoordelijke';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {ZahValidators} from '../../core/form/validators';

@Component({
    selector: 'zah-upsert-regioverantwoordelijke',
    templateUrl: './upsert-regioverantwoordelijke.component.html',
    styleUrls: ['./upsert-regioverantwoordelijke.component.scss'],
    standalone: false
})
export class UpsertRegioverantwoordelijkeComponent implements OnInit {

  @Input()
  regioverantwoordelijke?: Regioverantwoordelijke;
  @Input()
  okLabel: string;
  @Output()
  cancelClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  okClicked: EventEmitter<Regioverantwoordelijke> = new EventEmitter<Regioverantwoordelijke>();

  upsertRegioverantwoordelijkeForm: FormGroup;

  ngOnInit(): void {
    this.upsertRegioverantwoordelijkeForm = new FormGroup({
      voornaam: new FormControl(this.regioverantwoordelijke?.getVoornaam(), ZahValidators.notBlank),
      achternaam: new FormControl(this.regioverantwoordelijke?.getAchternaam(), ZahValidators.notBlank),
      personeelsnummer: new FormControl(
        {value: this.regioverantwoordelijke?.getPersoneelsnummer(), disabled: !!this.regioverantwoordelijke},
        ZahValidators.notBlank),
      email: new FormControl(
        {value: this.regioverantwoordelijke?.getEmail(), disabled: !!this.regioverantwoordelijke},
        [ZahValidators.notBlank, Validators.email]),
    });
  }

  onCancelClicked(): void {
    this.cancelClicked.emit();
  }

  onOkClicked(): void {
    this.okClicked.emit(new Regioverantwoordelijke(
      this.regioverantwoordelijke?.getId(),
      this.voornaam.value,
      this.achternaam.value,
      this.personeelsnummer.value,
      this.email.value,
      )
    );
  }

  get voornaam(): AbstractControl {
    return this.upsertRegioverantwoordelijkeForm.controls.voornaam;
  }

  get achternaam(): AbstractControl {
    return this.upsertRegioverantwoordelijkeForm.controls.achternaam;
  }

  get personeelsnummer(): AbstractControl {
    return this.upsertRegioverantwoordelijkeForm.controls.personeelsnummer;
  }

  get email(): AbstractControl {
    return this.upsertRegioverantwoordelijkeForm.controls.email;
  }
}
